/**
 * Description: This file include all functions and methods for management people catalogs
 */

import { gql } from "@apollo/client";

//Get Categories
export const OBTENER_CATEGORIAS_PERSONAS = gql`
  query OBTENER_CATEGORIAS_PERSONAS {
    listaCatPersonas {
      id
      clave
      categoria
    }
  }
`;

//Crear un nuevo registros
export const AGREGAR_PERSONA = gql`
  mutation AGREGAR_PERSONA($input: InputPersona) {
    agregarPersona(input: $input)
  }
`;

//Listar todos los registros
export const OBTENER_PERSONAS = gql`
  query OBTENER_PERSONAS {
    obtenerPersonas {
      id
      nombre
      apellidos
      baja
      CategoriaPersonasModel {
        id
        categoria
      }
    }
  }
`;

//oBTENER Una persona
export const OBTENER_INFO_PERSONA = gql`
  query OBTENER_PERSONA($id: ID!) {
    obtenerPersona(id: $id) {
      id
      nombre
      apellidos
      CatPersonaId
    }
  }
`;

//Editar la información
export const EDITAR_INFO_PERSONA = gql`
  mutation EDITAR_PERSONA($input: UpdatePersona) {
    editarPersona(input: $input)
  }
`;

//Desactivar un registro
export const DESACTIVAR_REGISTRO = gql`
  mutation DESACTIVARPERSONA($id: ID!) {
    desactivarPersona(id: $id)
  }
`;

//Activar Registro
export const ACTIVAR_REGISTRO = gql`
  mutation ACTIVARPERSONA($id: ID!) {
    activarPersona(id: $id)
  }
`;

//Eliminar Registro
export const ELIMINAR_REGISTRO = gql`
  mutation ELIMINARPERSONA($id: ID!) {
    eliminarRegistro(id: $id)
  }
`;
